'use client'

import * as React from 'react'
import { useMyAccountCardVariant } from '../_hooks/use-my-account-card-variant'
import { CardSkeleton } from './card'
import { MyAccountEmptyBlock } from './empty-block'
import { useTrendingNowProductsQuery } from '../_hooks/use-trending-now-products-query'
import { ProductBoxSlider, ProductBoxSliderFixedButtonsTrendingNow } from './product-box'
import { useTranslations } from 'next-intl'

export function MyAccountTrendingNow() {
  const { title, description } = useMyAccountCardVariant('trending-now')
  const { isPending, data } = useTrendingNowProductsQuery()
  const products = data?.products || []
  if (isPending) {
    return <CardSkeleton />
  }
  if (!products?.length) {
    return <MyAccountEmptyBlock variant="trending-now" />
  }
  return <ProductBoxSlider products={products} title={title} description={description} />
}

export function TrendingNowInfinite({
  withDownloadCTA,
  withSubtitle,
}: { withDownloadCTA?: boolean; withSubtitle?: boolean } = {}) {
  const t = useTranslations('components.product_box')

  return (
    <ProductBoxSliderFixedButtonsTrendingNow
      title={t('trending_now')}
      subtitle={withSubtitle ? t('trending_now_subtitle') : undefined}
      withDownloadCTA={withDownloadCTA}
    />
  )
}
